export function isPetitionId(idOrSlug: string): boolean {
	return !!/^\d+$/.exec(idOrSlug);
}
